import checkinIcon from 'assets/images/billing/licence_type_checkin.svg';
import checkoutIcon from 'assets/images/billing/licence_type_checkout.svg';
import crossIcon from 'assets/images/billing/licence_type_crossselling.svg';
import doorOpIcon from 'assets/images/billing/licence_type_door_opening.svg';
import guestRegIcon from 'assets/images/billing/licence_type_guest_registration.svg';
import guestLinkIcon from 'assets/images/billing/licence_type_guestlink.svg';
import integCostIcon from 'assets/images/billing/licence_type_integration_cost.svg';
import payProtIcon from 'assets/images/billing/licence_type_payment_protection.svg';
import upsellIcon from 'assets/images/billing/licence_type_upselling.svg';
import setupIcon from 'assets/images/billing/licence_type_setup.svg';
import pushIcon from 'assets/images/billing/licence_type_push.svg';
import paperlessIcon from 'assets/images/billing/licence_type_paperless.svg';
import ftpIcon from 'assets/images/billing/licence_type_ftp.svg';
import multitabletOptionIcon from 'assets/images/billing/licence_type_multitablet_option.svg';
import grsIcon from 'assets/images/billing/licence_type_grs.svg';
import hcnIcon from 'assets/images/billing/licence_type_hcn.svg';
import documentScannerIcon from 'assets/images/billing/licence_type_document_scanner.svg';
import facialRecognitionIcon from 'assets/images/billing/Facial recognition.svg';
import invoiceAutomationIcon from 'assets/images/billing/Invoice automation.svg';
import onlineCheckinAggregatorIcon from 'assets/images/billing/Online Check-in Aggregator.svg';
import automatedBookingLoadingIcon from 'assets/images/billing/Automated booking loading.svg';

const licenceIcons = {
  setup: setupIcon,
  integration_cost: integCostIcon,
  checkin: checkinIcon,
  upselling: upsellIcon,
  crossselling: crossIcon,
  payment_protection: payProtIcon,
  door_opening: doorOpIcon,
  guestlink: guestLinkIcon,
  guest_registration: guestRegIcon,
  checkout: checkoutIcon,
  push: pushIcon,
  paperless: paperlessIcon,
  ftp: ftpIcon,
  multitablet_option: multitabletOptionIcon,
  grs: grsIcon,
  hcn: hcnIcon,
  document_scanner: documentScannerIcon,
  facial_recognition: facialRecognitionIcon,
  invoice_automation: invoiceAutomationIcon,
  online_checkin_aggregator: onlineCheckinAggregatorIcon,
  automated_booking_loading: automatedBookingLoadingIcon,
};

export function getLicenceIconUrl(licenceName) {
  return licenceIcons[licenceName];
}
